import { Button, Col, Row } from "antd";
import "./Home_SectionOne.scss";
import { Link } from "react-router-dom";

function Home_SectionOne() {
  return (
    <>
      <div className="home-sectionOne">
        <div className="home-sectionOne-wrapper">
          <Row>
            <Col xxl={12} xl={12} lg={12} md={12}>
              <div className="home-sectionOne-content-left">
                <img
                  src="https://contentful.depop.com/itoh30v6uh9a/25qBMrtTmRUr1Dfil9u5lH/72cde8569ccb4bf1ba17a3126a49771e/WW.png"
                  alt="Img Woman"
                />

                <div className="content-main">
                  <div className="content-main-title">Nữ</div>
                  <Link to="/Woman">
                    <Button className="home-sectionOne-btnBuy">Mua ngay</Button>
                  </Link>
                </div>
              </div>
            </Col>

            <Col xxl={12} xl={12} lg={12} md={12}>
              <div className="home-sectionOne-content-left">
                <img
                  src="https://contentful.depop.com/itoh30v6uh9a/5Cszb1OnWwy3dpjxqenWGS/336d75a8379ff1ce8b00dd05e44f7229/MW.png"
                  alt="Img Woman"
                />

                <div className="content-main">
                  <div className="content-main-title">Nam</div>
                  <Link>
                    <Button className="home-sectionOne-btnBuy">Mua ngay</Button>
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}

export default Home_SectionOne;
